import { useState, useMemo } from "react";
import { createTheme } from "@mui/material/styles";

export function useThemeMode() {
    const [mode, setMode] = useState("light");

    const toggleMode = () => {
        setMode((prev) => (prev === "light" ? "dark" : "light"));
    };

    const theme = useMemo(
        () =>
            createTheme({
                palette: {
                    mode,
                    navBar: {
                        main: "#000",   // azul oscuro
                        contrastText: "#fff",
                    },
                    iconoBlanco: {
                        main: "#fff"
                    },
                    green: {
                        main: '#20BC71'
                    },
                    white: {
                        main: '#ffffff5f'
                    }
                },
                typography: {
                    fontFamily: "Aspekta, Arial, sans-serif",
                },
                components: {
                },
            }),
        [mode]
    );



    return { theme, mode, toggleMode };
}
